module.exports = __webpack_public_path__ + "img/time_line_circular_connect_head_title.03ad0e3a.svg";